
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/filteringAndSorting/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pages-pages-reference-filtering-and-sorting-demo-base","pages-pages-reference-filtering-and-sorting-demo-multiple","pages-pages-reference-filtering-and-sorting-demo-filters"],
  getter: () => import(/* webpackChunkName: "meta__p" */'/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/pages/reference/filteringAndSorting/index.md?type=demo')
};